import type { ResultData, ResultItem } from '@/domain';

export const apiListAdImageWrapper = (res: ResultData): ResultData => {
    if (res?.resultItems && Array.isArray(res.resultItems)) {
        fixAdImages(res.resultItems);
    }
    return res;
};

const fixAdImages = (images: ResultItem[]) => {
    images
        .filter((item) => item.imageurl !== undefined)
        .forEach((item) => {
            item.imageurl = prependImageUrl(item.imageurl);
        });
};

export const prependImageUrl = (imageUrl: string): string => {
    if (imageUrl.includes('http')) {
        return imageUrl;
    } else {
        return `https://images.finncdn.no/dynamic/default/${imageUrl}`;
    }
};
